import React from 'react';
import '../../styles/styles.css';


export default function arunachalam() {
  return (
    <div className="container mt-4">
        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/Arunachalam.jpg" alt="Thiruvannamlai" />    
            </div>

            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Next Festival Date in Arunachalam<br />
    Karthigai Deepam (Maha Deepam) : 04th December, 2025<br />    
    <br />

  </strong></p>
  <p>Registration link to Arunchaleswar Temple : <a href="https://annamalaiyar.hrce.tn.gov.in/hrcehome/index_temple.php?tid=20343" target="_blank" rel="noopener noreferrer">
  Annamalaiyar Official Website
</a>
</p>
</div>
            </div>
        </div>

        {/* Bottom Full Width Description Box */}
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Arulmigu Annamalaiyar Temple, known as Arulmigu Arunchaleswarar Temple, is beautifully situated at the foothills of a 2668 feet high hill in Tiruvannamalai, a holy city in South India and one that can bring salvation if you think about it. The temple is a fine example of South Indian (Dravidian) architecture and sculpture. According to the inscriptions written in this temple, this temple was built during the period of the early Chola kings (9th century AD), expanded during the period of the later Cholas, Hoysala (Bhosala) kings, and Vijayanagarar Nayakar kings, and The temple was built with a row of stone pillars and sub shrines of many deities including Amman shrine, 9 towers, 5 praharas, many mandapas, and sanctum sanctorums with grand our structures.</p>
             </div>
        </div>
<div className="row mt-3">
        <div className="col-12">
          <div className="Desc-box3">
            <h2 className="live-header">Arunchalam/Thiruvannamalai Temple</h2>
            <div className="youtube-container">
              <iframe
                src="https://www.youtube.com/embed/g3FM3dsxT3I?rel=0&modestbranding=1&showinfo=0"
                title="Arunchalam/Thiruvannamalai Temple"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>

  </div>
</div>
</div>


  )
}
